<template>
  <v-card
    tile
  >
    <v-img
      :src="cardImage"
    />
    <v-card-title>
      マインクラフトでプログラミングする準備の手順書
    </v-card-title>
    <v-card-subtitle>
      マインクラフトでPythonのプログラミングをするための準備について詳しく解説します
    </v-card-subtitle>
    <v-card-text>
      マインクラフトでプログラミングを始めるにはセットアップが必要です<br/>手順に従ってセットアップを進めればマイクラでプログラミングを始められます
    </v-card-text>
    <v-card-actions>
      <a href="/textbooks/GettingStartedMinecraftProgramming/">
        <v-btn
          color="purple"
          text
        >
          無料で読む
        </v-btn>
      </a>
    </v-card-actions>
  </v-card>
</template>

<script>
import Image from '@/assets/img/textbooks/ready-for-minecraft-programming.jpg'

export default {
  name: 'VReadyForMineCraftProgramming',
  data() {
    return {
      cardImage: Image
    }
  }
}
</script>